import { h } from "preact";

import i18n from "../../i18n";

import Button from "../Button.jsx";
import List from "../List.jsx";
import ListItem from "../ListItem.jsx";
import TaskLink from "../TaskLink.jsx";

export default {
  registration_start: ({ onNext }) => {
    return (
      <section class="task-page">
        <h1 class="task-page__headline">Registration</h1>

        <div class="task-page__content">
          <p>
            Please register with the competent registration authority of your
            municipality.
          </p>

          <List class="mb-32">
            <ListItem number={1}>
              Schedule a meeting at the registration authority.
              <TaskLink id="registration_authority" class="ml-16" />
            </ListItem>
            <ListItem number={2}>
              Show up on time with the required documents.
              <TaskLink id="registration_documents" class="ml-16" />
            </ListItem>
            <ListItem number={3}>Register in Germany.</ListItem>
            <ListItem number={4}>
              Keep your registration certificate in a safe place.
            </ListItem>
          </List>
          <List>
            <ListItem secondLine="Your Tax ID will arrive separately in the post within 2-3 weeks. You will need it together with your registration certificate for all kinds of administrative tasks.">
              Tipp
            </ListItem>
          </List>

          <p>
            Was your registration successful? Please pass this information on to
            Nioomi.
          </p>
        </div>

        <div class="task-page__buttons">
          <Button onClick={onNext}>{i18n.t("actions.enter_result")}</Button>
        </div>
      </section>
    );
  },

  registration_yes: ({ onNext, onRestart }) => {
    return (
      <section class="task-page">
        <h1 class="task-page__headline">
          {i18n.t("pages.common.result_title")}
        </h1>

        <div class="task-page__content">
          <List class="mb-32">
            <ListItem iconFront="check" overline="Registration">
              You have successfully registered at your new address.
            </ListItem>
          </List>
        </div>

        <div class="task-page__buttons">
          <Button onClick={onNext}>{i18n.t("actions.ok")}</Button>
          <Button text class="mr-16" onClick={onRestart}>
            {i18n.t("actions.discard_result")}
          </Button>
        </div>
      </section>
    );
  },

  registration_no: ({ onNext, onRestart }) => {
    return (
      <section class="task-page">
        <h1 class="task-page__headline">
          {i18n.t("pages.common.result_title")}
        </h1>

        <div class="task-page__content">
          <List class="mb-32">
            <ListItem
              iconFront="warning"
              overline="Registration"
              secondLine="Your professional qualification is not equivalent, or you do not meet the further criteria."
            >
              You were unable to registered at your new address.
            </ListItem>
          </List>
        </div>

        <div class="task-page__buttons">
          <Button onClick={onNext}>{i18n.t("actions.ok")}</Button>
          <Button text class="mr-16" onClick={onRestart}>
            {i18n.t("actions.discard_result")}
          </Button>
        </div>
      </section>
    );
  },
};
